module.exports = __webpack_public_path__ + "static/media/1022889.7476ecab.png";